import { ProductType, selectIsAuthenticated, } from "common";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { fetchProductAttempt } from "store/products/productActions";
import { selectProduct } from "store/products/productSelectors";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import { addToCart, editToCart, selectProductToModify } from "store/cart/cartActions";
import Img from "components/Img/Img";
import "./ProductDetail.scss";
import useModal from "shared/hooks/useModal";
import { truncate } from "shared/helpers";
import { selectCartProducts, selectProductAddedToCart, selectProductIndexToModify } from "store/cart/cartSelectors";
import { CheckMarkAnimation } from "components/Animations/CheckMarkAnimation";
import { ProductForm } from "../Form/ProductForm";
import { FormattedMessage, useIntl } from "react-intl";
import { selectProfileInfos } from "store/account/profile/profileSelectors";
import { selectTags } from "store/tags/tagSelectors";
import { fetchTagsAttempt } from "store/tags/tagActions";
import ProductListItem from "../components/ProductListItem";
import { Modal } from "components/Modal/Modal";
function ProductDetail() {
    var _a, _b, _c, _d, _e, _f, _g;
    const [MODAL_ID] = useState('freeProductsModal');
    const [reviewId, setReviewId] = useState('');
    const { slug } = useParams();
    const dispatch = useDispatch();
    const { toggleModal, closeModal } = useModal();
    const productAddedToCart = useSelector(selectProductAddedToCart);
    const IS_B2C = (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.__env__) === null || _b === void 0 ? void 0 : _b.APP_MODE) == 'B2C') ? true : false;
    const isAuthenticated = IS_B2C ? true : useSelector(selectIsAuthenticated());
    const productIndexToModify = useSelector(selectProductIndexToModify);
    const products = useSelector(selectCartProducts);
    const selectedProductToModify = products[productIndexToModify];
    const product = useSelector(selectProduct(slug));
    const user = useSelector(selectProfileInfos);
    console.log('product', product);
    const tags = useSelector(selectTags);
    function slugify(text) {
        const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        const to = "aaaaaeeeeeiiiiooooouuuunc------";
        if (!text) {
            return '';
        }
        const newText = text.split('').map((letter, i) => letter.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)));
        return newText
            .toString()
            .toLowerCase()
            .trim()
            .replace('#', '-')
            .replace(/\s+/g, '-')
            .replace(/&/g, '-y-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-');
    }
    useEffect(() => {
        dispatch(fetchTagsAttempt());
        dispatch(fetchProductAttempt(slug));
        const currentTag = tags.find(obj => obj._id === product.tag);
        console.log('currentTag', currentTag);
        return () => {
            dispatch(selectProductToModify(null));
        };
    }, [dispatch, slug, isAuthenticated]);
    useEffect(() => {
        setReviewId(product === null || product === void 0 ? void 0 : product.reviewId);
    }, [product]);
    const onSubmit = (cartProduct) => {
        !!selectedProductToModify
            ? dispatch(editToCart(Object.assign(Object.assign({}, cartProduct), { quantity: +cartProduct.quantity })))
            : dispatch(addToCart(Object.assign(Object.assign({}, cartProduct), { quantity: +cartProduct.quantity })));
        closeModal(MODAL_ID);
    };
    const intl = useIntl();
    console.log(product);
    return (React.createElement("div", { className: "k-product" }, !!product && !!tags && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "k-product--breadcrumb" },
            React.createElement("ol", { className: "k-topbar--items" },
                React.createElement("li", { className: "k-topbar--item" },
                    React.createElement(Link, { className: "k-topbar--label", "data-text": "Accueil", to: "/" }, "Accueil")),
                React.createElement("li", { className: "k-topbar--item" },
                    React.createElement(Link, { className: "k-topbar--label", "data-text": "Produits", to: "/nos-produits" }, "Produits")),
                React.createElement("li", { className: "k-topbar--item" },
                    React.createElement(Link, { className: "k-topbar--label", "data-text": (_c = tags.find(obj => obj._id === product.tag)) === null || _c === void 0 ? void 0 : _c.name, to: `/nos-produits/categorie/` + slugify((_d = tags.find(obj => obj._id === product.tag)) === null || _d === void 0 ? void 0 : _d.name) }, (_e = tags.find(obj => obj._id === product.tag)) === null || _e === void 0 ? void 0 : _e.name)),
                React.createElement("li", { className: "k-topbar--item" },
                    React.createElement(Link, { className: "k-topbar--label", "data-text": product.name, to: `/nos-produits/${product.slug}` }, product.name)))),
        React.createElement("div", { className: "k-product--detail" },
            React.createElement("div", { className: "k-product--detail_viz" },
                React.createElement("div", { className: "k-product--img" },
                    React.createElement(Img, { src: product.imageUrl[0], name: product.name, alt: product.name }))),
            React.createElement("div", { className: "k-product--detail_data" },
                React.createElement("div", null,
                    React.createElement(Helmet, null,
                        React.createElement("title", null, product.metaTitle || product.name),
                        product.metaDescription
                            ? React.createElement("meta", { name: "description", content: product.metaDescription })
                            : React.createElement("meta", { name: "description", content: truncate(`${product === null || product === void 0 ? void 0 : product.description}`, 150) }),
                        product.metaKeywords && React.createElement("meta", { name: "keywords", content: product.metaKeywords }),
                        React.createElement("link", { rel: "canonical", href: (typeof window !== 'undefined' && ((_f = window) === null || _f === void 0 ? void 0 : _f.location))
                                ? `${window.location.origin}/nos-produits/${product.slug}`
                                : `https://pro.kust.fr/nos-produits/${product.slug}` }),
                        React.createElement("script", { type: "application/ld+json" }, `{
                  "@context": "https://schema.org/",
                  "@type": "Product",
                  "name": "${product.name}",
                  "image": ["${product.imageUrl[0]}"],
                  "description": "${product.description}",
                  "sku": "${product.code}",
                  "brand": {
                    "@type": "Brand",
                    "name": "KUST"
                  }
                }`)),
                    React.createElement("h1", { className: "k-product--title" },
                        React.createElement(FormattedMessage, { id: product.name, defaultMessage: product.name })),
                    product.promoText &&
                        React.createElement("div", { className: "k-product--discount" },
                            React.createElement("span", null, product.promoText)),
                    React.createElement("div", { className: "k-product--description", dangerouslySetInnerHTML: { __html: product.description } }),
                    !!product.informations &&
                        React.createElement("div", { className: "k-product--complement more-infos" },
                            React.createElement("p", null,
                                React.createElement(FormattedMessage, { id: product.informations, defaultMessage: product.informations })),
                            !!product.informationsLink && React.createElement(Link, { to: `${product === null || product === void 0 ? void 0 : product.informationsLink}` },
                                React.createElement(FormattedMessage, { id: "En savoir plus", defaultMessage: "En savoir plus" }))))),
            React.createElement("section", { className: "k-product--order", id: "k-anchor--1" },
                React.createElement("header", null,
                    React.createElement("h2", null, "Votre s\u00E9lection"),
                    !isAuthenticated &&
                        React.createElement(React.Fragment, null,
                            React.createElement("p", null,
                                React.createElement(FormattedMessage, { id: "Pour consulter les tarifs, vous devez \u00EAtre un.e professionnel.l.e enregistr\u00E9.e puis connect\u00E9.e.", defaultMessage: "Pour consulter les tarifs, vous devez \u00EAtre un.e professionnel.l.e enregistr\u00E9.e puis connect\u00E9.e." }),
                                React.createElement("br", null),
                                React.createElement(FormattedMessage, { id: "Utilisez le bouton de connexion en bas de l'\u00E9cran.", defaultMessage: "Utilisez le bouton de connexion en bas de l'\u00E9cran." })),
                            !!product.button &&
                                React.createElement("span", null,
                                    React.createElement(FormattedMessage, { id: "ou :", defaultMessage: "ou :" }),
                                    React.createElement("a", { href: "https://particuliers.kust.fr" },
                                        React.createElement(FormattedMessage, { id: "Je suis un particulier", defaultMessage: "Je suis un particulier" }))))),
                React.createElement(Formik, { validateOnChange: true, initialValues: Object.assign(Object.assign({}, product), { quantity: product.type === ProductType.SIMPLE_PRODUCT ? 0 : 1, element: !!selectedProductToModify ? selectedProductToModify === null || selectedProductToModify === void 0 ? void 0 : selectedProductToModify.element : null, choices: !!selectedProductToModify ? selectedProductToModify === null || selectedProductToModify === void 0 ? void 0 : selectedProductToModify.choices : product === null || product === void 0 ? void 0 : product.choices }), enableReinitialize: true, onSubmit: (values, actions) => {
                        onSubmit(values);
                        actions.resetForm();
                    } },
                    React.createElement(ProductForm, { product: product, setReviewId: setReviewId, modalId: MODAL_ID, toggleModal: toggleModal }))),
            product.userGuide && product.userGuide.trim().length > 10 && (React.createElement("section", { className: "k-product--guide" },
                React.createElement("header", null,
                    React.createElement("h2", null,
                        React.createElement("i", null, "Nos conseils"),
                        " d'utilisation")),
                React.createElement("div", { className: "k-product--guide_content", dangerouslySetInnerHTML: { __html: product.userGuide } }),
                product.ingredients && product.ingredients.trim().length > 10 && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement("a", { onClick: () => { toggleModal('ingredients'); } }, "Voir les ingr\u00E9dients"))))),
            ((_g = product === null || product === void 0 ? void 0 : product.products) === null || _g === void 0 ? void 0 : _g.length) > 0 &&
                React.createElement("section", { className: "k-product--suggestions k-highlight k-highlight--black" },
                    React.createElement("header", { className: "k-highlight--header" },
                        React.createElement("h2", null,
                            React.createElement("span", null,
                                React.createElement(FormattedMessage, { id: "Nos produits", defaultMessage: "Nos produits" })),
                            React.createElement("i", null,
                                React.createElement(FormattedMessage, { id: "compl\u00E9mentaires", defaultMessage: "compl\u00E9mentaires" }))),
                        product.complementaryText && React.createElement("p", null,
                            React.createElement(FormattedMessage, { id: product.complementaryText, defaultMessage: product.complementaryText }))),
                    React.createElement("div", { className: "k-highlight--items" }, product === null || product === void 0 ? void 0 : product.products.map((similar) => {
                        return (React.createElement(ProductListItem, { framed: true, path: `/nos-produits/${similar.slug}`, product: similar }));
                    }))),
            React.createElement(CheckMarkAnimation, { message: intl.formatMessage({ id: "Produit(s) ajouté(s) à votre panier !", defaultMessage: "Produit(s) ajouté(s) à votre panier !" }), isActive: productAddedToCart })),
        React.createElement(Modal, { id: 'ingredients' },
            React.createElement("div", { style: { color: 'white', textAlign: 'center' } },
                React.createElement("div", { className: "other-content", dangerouslySetInnerHTML: { __html: product.ingredients } })))))));
}
export default ProductDetail;
